export default {
	messages: {
		de: { country: 'Land' },
		en: { country: 'Country' },
	},
};
